import styled from "styled-components";

export const CMBackArrow = styled.div(props => ({
    position: 'absolute',
    left: '3vw',
    top: '3vw',
    cursor: 'pointer',
    
    [`@media (min-width: 2000px)`]: {
        "& img":{
          width:"2vw !important",
         }
      },
    
    [`@media${props.theme.breakpoints.lg}`]: {                
        marginRight: "5%",        
    },
    [`@media${props.theme.breakpoints.sm}`]: {                
        top: '0',        
    }
}));